class HHPriceFormatter extends HTMLElement {
  constructor() {
    super()
    this.price = this.getAttribute('price') || 9999
    this.locale = this.getAttribute('locale') || 'en-US'
    this.currency = this.getAttribute('currency') || 'USD'
  }

  connectedCallback() {
    this.innerHTML = this.formatPrice(this.price, this.locale, this.currency)
  }

  formatPrice(price, locale, currency) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(price / 100)
  }
}

customElements.define('hh-price-formatter', HHPriceFormatter)
